import React from "react"

interface ToggleProps {
  initialValue?: boolean
  onChange: (value: boolean) => void
  rightLabel: string
  leftLabel: string
  textSize?: "sm" | "base" | "lg"
}

function Toggle({
  initialValue,
  onChange,
  rightLabel,
  leftLabel,
  textSize = "lg",
}: ToggleProps) {
  const [checked, setChecked] = React.useState(initialValue)

  const sizeClass =
    textSize === "sm"
      ? "text-sm"
      : textSize === "base"
        ? "text-base"
        : "text-lg"

  return (
    <label className="grid grid-cols-3 items-center gap-4 cursor-pointer">
      <span
        className={`font-medium ${checked ? "text-swift-orange" : "text-gray-300"} ${sizeClass} text-right`}
      >
        {leftLabel}
      </span>
      <div className="flex justify-center">
        <input
          type="checkbox"
          defaultChecked={initialValue === false}
          value={checked ? "true" : "false"}
          className="sr-only peer"
          onChange={(e) => {
            onChange(e.target.value === "true" ? true : false)
            setChecked(!checked)
          }}
        />
        <div className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-swift-orange after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-swift-orange after:border-swift-orange after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-gray-300"></div>
      </div>
      <span
        className={`${sizeClass} font-medium ${checked ? "text-gray-300" : "text-swift-orange"}`}
      >
        {rightLabel}
      </span>
    </label>
  )
}

export default Toggle
